import React from 'react';
import DefaultToolTipBody from './ToolTipComponents/DefaultToolTipBody';
import CheckEveryHeader from './ToolTipComponents/CheckEveryHeader';
import DefaultButtonRow, {
  WorkflowStepActionButtonProps,
} from './ToolTipComponents/DefaultButtonRow';
import { CheckEveryAnnotationToolTipProps } from '../types';

const CheckEveryParentToolTip: React.FC<CheckEveryAnnotationToolTipProps> = props => {
  const { completeAndMoveNext, moveNextStep } = props.workflowHook;

  const actionButtonProps: WorkflowStepActionButtonProps = {
    completedText: 'Redo Checks',
    startedText: 'Complete',
    startedStateClick: completeAndMoveNext,
    allChildrenCompletedText: 'Complete',
    allChildrenCompletedStateClick: completeAndMoveNext,
    uncompletedText: 'Start',
    uncompletedStateClick: moveNextStep,
  };

  return (
    <div>
      <CheckEveryHeader
        workflowHook={props.workflowHook}
        labelerStateHook={props.labelerStateHook}
      />
      <DefaultToolTipBody workflowHook={props.workflowHook} />
      <DefaultButtonRow workflowHook={props.workflowHook} actionButtonProps={actionButtonProps} />
    </div>
  );
};

export default React.memo(CheckEveryParentToolTip);
